import React from 'react';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import {
  nonRiskyComorbidity,
  riskyComorbidity,
  specificRiskRiskyDna,
  specificRiskNotRisky,
  specificRiskModerate,
} from 'on_web/assets/imageList';

/**
 * Component displaying condition summary.
 * @param {Component properties} props
 */
export default function ConditionSummary(props) {
  const useStyles = makeStyles(() => ({
    root: {
      flexGrow: 1,
      backgroundColor: '#f2f2f2',
    },
  }));

  const classes = useStyles();

  return (
    <div
      className={classes.root}
      onClick={() => {
        if (props.onClick) {
          props.onClick(props.comorbidityCode);
        }
      }}
    >
      <Box px={'20px'} py={'12px'}>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          <Grid item xs={6} sm={6}>
            <span
              style={{
                fontFamily: 'MuseoSans-500',
                fontSize: 16,
                color: '#2a343f',
              }}
            >
              {props.conditionName}
            </span>
          </Grid>
          <Grid item xs={5} sm={5}>
            <div>
              <Grid
                container
                direction="column"
                justify="center"
                alignItems="flex-end"
              >
                <img
                  src={
                    props.isDna
                      ? props.level === 2
                        ? specificRiskRiskyDna
                        : props.level === 1
                        ? specificRiskModerate
                        : specificRiskNotRisky
                      : props.level === 0
                      ? nonRiskyComorbidity
                      : riskyComorbidity
                  }
                  width={25}
                />
              </Grid>
            </div>
          </Grid>
          <Grid item xs={1} sm={1}>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="flex-end"
            >
              <KeyboardArrowRightIcon />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

ConditionSummary.propTypes = {
  /**
   * Name of the condition
   */
  conditionName: PropTypes.string.isRequired,

  /**
   * Condition level
   */
  level: PropTypes.number.isRequired,

  /**
   * Condition risk
   */
  conditionRisk: PropTypes.string.isRequired,
};
